import React, { useEffect, useState } from 'react'

import { useLocation } from "@reach/router"

import { SlideinWrap, SlideinItem } from 'src/components/slidein/index'

import Link from 'src/components/link/index'
import Date from 'src/components/datetime/date'

import * as styles from './overview.module.scss'


const Overview = ({ data }) => {

    const { href } = useLocation()

    const [url, setURL] = useState(``)

    const clip = () => {
        window.navigator.clipboard.writeText(url)
        window.alert('URLをクリップボードにコピーしました。')
    }

    useEffect(() => {
        setURL(href)
    }, [setURL, href])

    return (
        <SlideinWrap rate={0.1} className={styles.overview}>
            <div className={styles.content}>
                <div className={styles.inner}>
                    <SlideinItem delay={100} className={styles.tags}>
                        <span>{data.article.tags.nodes[0].name}</span>
                    </SlideinItem>
                    <SlideinItem delay={200} tagName="h1" className={styles.title}>
                        <span data-size={data.article.custom.titleSize}>{data.article.custom.title}</span>
                    </SlideinItem>
                    <SlideinItem delay={300} className={styles.datetime}>
                        <Date dateText={data.article.custom.datetime} />
                    </SlideinItem>
                    <SlideinItem delay={400} className={styles.share}>
                        <ul>
                            <li><Link to={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} className={styles.facebook}>facebook</Link></li>
                            <li><Link to={`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`} className={styles.twitter}>twitter</Link></li>
                            <li><Link to={`https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(url)}`} className={styles.line}>LINE</Link></li>
                            <li><button onClick={clip} className={styles.clip}>clip</button></li>
                        </ul>
                    </SlideinItem>
                    <SlideinItem delay={500} className={styles.lead}>
                        <p>{data.article.custom.lead}</p>
                    </SlideinItem>
                </div>
            </div>
        </SlideinWrap>
    )
}

export default Overview